import T from 'T'

export const OFFICE_PERMISSION = 100
export const ROAD_PERMISSION = 101

export const EXPAND = 100
export const COMPLETE = 101
export const SKIP = 102
export const NONE = 103

// Mirrors crm-common CrudType — an ascending ladder, so each level implies the ones below it.
// FULL_PERMISSION is CrudType.CREATE; DELETE sits above it.
export const NO_ACCESS_PERMISSION = 100
export const READ_PERMISSION = 101
export const UPDATE_PERMISSION = 102
export const FULL_PERMISSION = 103
export const DELETE_PERMISSION = 104

export const CAPTURE_MAPPINGS = {
  [T.SAFETY]: 'dcSafety',
  [T.DELAY]: 'dcDelay',
  [T.NO_ACCESS]: 'dcNoAccess',
  [T.DAMAGE]: 'dcDamage',
  [T.OVERLOADED]: 'dcOverloaded',
  [T.EXTRA_ITEM]: 'dcExtraItem',
  [T.SPECIAL]: 'dcSpecialItem',
  [T.CONTAMINATION]: 'dcContamination',
  [T.SERVICE_REVIEW]: 'dcServiceReview',
  [T.WEIGHT]: 'dcWeight',
  [T.CAMERA]: 'dcCamera',
  [T.SIGNATURE]: 'dcSignature',
  [T.NOTE]: 'dcNote',
  [T.SERIAL_NUMBER]: 'dcSerialNumber',
}

export const FUNCTIONS_MAPPINGS = {
  [T.SAFETY]: [T.PHOTO, T.NOTE],
  [T.DELAY]: [T.PHOTO, T.NOTE, T.TIMER],
  [T.NO_ACCESS]: [T.PHOTO, T.NOTE],
  [T.DAMAGE]: [T.PHOTO, T.NOTE, T.SIGNATURE],
  [T.OVERLOADED]: [T.PHOTO, T.NOTE],
  [T.EXTRA_ITEM]: [T.PHOTO, T.NOTE, T.NUMBER],
  [T.SPECIAL]: [T.PHOTO, T.NOTE, T.NUMBER],
  [T.CONTAMINATION]: [T.PHOTO, T.NOTE],
  [T.SERVICE_REVIEW]: [T.PHOTO, T.NOTE],
  [T.WEIGHT]: [T.PHOTO, T.NOTE, T.NUMBER],
  [T.CAMERA]: [T.PHOTO],
  [T.SIGNATURE]: [T.SIGNATURE],
  [T.NOTE]: [T.NOTE],
  [T.SERIAL_NUMBER]: [T.NUMBER, T.PHOTO],
}

export const EXCEPTIONS = [
  T.SAFETY,
  T.DELAY,
  T.NO_ACCESS,
  T.DAMAGE,
  T.OVERLOADED,
  T.EXTRA_ITEM,
  T.SPECIAL,
  T.CONTAMINATION,
  T.SERVICE_REVIEW,
  T.WEIGHT,
  T.CAMERA,
  T.SIGNATURE,
  T.NOTE,
  T.SERIAL_NUMBER,
]

export const DISPLAY_MAPPINGS = {
  [T.SHOW_MILES_ON_ROUTE_LIST]: 'mrcShowMiles',
  [T.PURCHASE_ORDER]: 'mrcPurchaseOrder',
  [T.MATERIAL]: 'mrcMaterial',
  [T.MEASURE]: 'mrcMeasure',
  [T.SERVICE]: 'mrcService',
  [T.SCHEDULE]: 'mrcSchedule',
  [T.SEQUENCE]: 'mrcSequence',
  [T.DATE]: 'mrcDate',
  [T.QTY]: 'mrcQuantity',
}

export const DISPLAY_OPTIONS = [
  T.SHOW_MILES_ON_ROUTE_LIST,
  T.PURCHASE_ORDER,
  T.MATERIAL,
  T.MEASURE,
  T.SERVICE,
  T.SCHEDULE,
  T.SEQUENCE,
  T.DATE,
  T.QTY,
]

export const ACCESS_VALUES = ['', T.NONE, T.VIEW, T.EDIT, T.FULL]

export const PERMISSION_MAPPINGS = {
  [T.CUSTOMER_INFORMATION]: 'customerInformationCrud',
  [T.TRUCK]: 'truckCrud',
  [T.ROUTE]: 'routeCrud',
  [T.AUTO_COMPLETE]: 'autocompleteCrud',
  [T.TIMER]: 'timerCrud',
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.INSPECTION_REPAIRS]: 'inspectionRepairsCrud',
}

export const ALLOWED_PERMISSIONS = {
  [T.CUSTOMER_INFORMATION]: [NO_ACCESS_PERMISSION, READ_PERMISSION],
  [T.TRUCK]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION],
  [T.ROUTE]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION],
  [T.AUTO_COMPLETE]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION],
  [T.TIMER]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION],
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.INSPECTION_REPAIRS]: [NO_ACCESS_PERMISSION, FULL_PERMISSION],
}

export const PERMISSION_TOOLTIP_VALUES = [
  T.VIEW_CONTACT_INFO,
  T.ABILITY_TO_CHANGE_TRUCK,
  T.ABILITY_TO_CHANGE_ROUTE,
  T.ALLOW_TIMER,
  T.INSPECTION_REPAIRS_INFO,
]

export const PERMISSION_RECORDS = [T.CUSTOMER_INFORMATION, T.TRUCK, T.ROUTE, T.TIMER, T.INSPECTION_REPAIRS]

export const OFFICE_MAPPING = {
  [T.SETTINGS]: 'settingsCrud',
  [`${T.ROLE}s`]: 'permissionsCrud',
  [T.USER]: 'userCrud',
  [T.RESET_PASSWORD]: 'resetPasswordCrud',
  [T.PRICING_MANAGER]: 'pricingManagerCrud',
  [T.BILLING]: 'billingCrud',
  [T.CUSTOMER_BILLING_PROFILE]: 'customerBillingProfileCrud',
  [`${T.INVOICE}s`]: 'invoicesCrud',
  [T.POST_INVOICES_PAYMENT]: 'postInvoicesPaymentCrud',
  [T.PAYMENTS]: 'paymentsCrud',
  [T.ACCOUNT_PERIOD_LOCK]: 'lockDateCrud',
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.CHANGE_DATE_ON_INVOICED_WORK_ORDERS]: 'invoicedWorkOrderDateCrud',
  [T.SERVICE]: 'serviceCrud',
  [T.CONFIGURED_SERVICE_PRICE]: 'configuredServicePriceCrud',
  [T.CUSTOMER_MANAGER]: 'customerManagerCrud',
  [T.ROUTE_MANAGER]: 'routeManagerCrud',
  [`${T.FOLLOW_UP}s`]: 'followUpCrud',
  [`Any ${T.FOLLOW_UP}`]: 'anyFollowUpCrud',
  [T.DASHBOARD]: 'dashboardCrud',
  [T.REPORTS]: 'reportsCrud',
  [T.GLOBAL_SEARCH]: 'globalSearchCrud',
  [T.MESSAGING]: 'messagingCrud',
  [T.TAXES]: 'taxCrud',
  [T.TAX_APPLICATION]: 'taxApplicationCrud',
  [T.ZONES]: 'geoZoneCrud',
  [T.NOTIFICATIONS]: 'notificationCrud',
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.INSPECTIONS]: 'inspectionsCrud',
}

export const OFFICE_ALLOWED_PERMISSIONS = {
  [T.SETTINGS]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [`${T.ROLE}s`]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.USER]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.RESET_PASSWORD]: [NO_ACCESS_PERMISSION, UPDATE_PERMISSION],
  [T.PRICING_MANAGER]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.BILLING]: [NO_ACCESS_PERMISSION, READ_PERMISSION],
  [T.CUSTOMER_BILLING_PROFILE]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [`${T.INVOICE}s`]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.POST_INVOICES_PAYMENT]: [NO_ACCESS_PERMISSION, UPDATE_PERMISSION],
  [T.PAYMENTS]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.ACCOUNT_PERIOD_LOCK]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.CHANGE_DATE_ON_INVOICED_WORK_ORDERS]: [NO_ACCESS_PERMISSION, UPDATE_PERMISSION],
  [T.SERVICE]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.CONFIGURED_SERVICE_PRICE]: [READ_PERMISSION, UPDATE_PERMISSION],
  [T.CUSTOMER_MANAGER]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.ROUTE_MANAGER]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [`${T.FOLLOW_UP}s`]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [`Any ${T.FOLLOW_UP}`]: [READ_PERMISSION, UPDATE_PERMISSION],
  [T.DASHBOARD]: [NO_ACCESS_PERMISSION, READ_PERMISSION],
  [T.REPORTS]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.GLOBAL_SEARCH]: [NO_ACCESS_PERMISSION, READ_PERMISSION],
  [T.MESSAGING]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  [T.TAXES]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  // Tax application has no create or archive endpoint — every write requires only UPDATE
  [T.TAX_APPLICATION]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION],
  [T.ZONES]: [NO_ACCESS_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION, FULL_PERMISSION],
  // READ already covers marking read/unread; UPDATE is reserved and behaves identically today.
  [T.NOTIFICATIONS]: [NO_ACCESS_PERMISSION, READ_PERMISSION],
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.INSPECTIONS]: [NO_ACCESS_PERMISSION, READ_PERMISSION, FULL_PERMISSION],
}

export const OFFICE_TOOLTIP_TEXT = {
  [T.SETTINGS]: T.ACCESS_MODIFY_SETTINGS,
  [`${T.ROLE}s`]: T.MODIFY_PERMISSIONS_IN_ROLES,
  [T.USER]: T.CREATE_USER_INFO,
  [T.RESET_PASSWORD]: T.RESET_USER_PWD,
  [T.PRICING_MANAGER]: T.CREATE_USER_INFO,
  [T.BILLING]: T.BILLING_INFO,
  [T.CUSTOMER_BILLING_PROFILE]: T.VIEW_CUSTOMER_BILLING_PROFILE,
  [`${T.INVOICE}s`]: T.BILLING_INVOICES,
  [T.POST_INVOICES_PAYMENT]: T.POST_INVOICES_PAYMENTS,
  [T.PAYMENTS]: T.PAYMENT_PERMISSION_NOTE,
  [T.ACCOUNT_PERIOD_LOCK]: T.LOCK_DATE_INFO,
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.CHANGE_DATE_ON_INVOICED_WORK_ORDERS]: T.CHANGE_DATE_ON_INVOICED_WORK_ORDERS_INFO,
  [T.SERVICE]: T.SERVICE_INFO,
  [T.CONFIGURED_SERVICE_PRICE]: T.CONFIGURED_SERVICE_PRICE_INFO,
  [T.CUSTOMER_MANAGER]: T.CUSTOMER_MANAGER_INFO,
  [T.ROUTE_MANAGER]: T.ROUTE_INFO,
  [`${T.FOLLOW_UP}s`]: T.FOLLOWUPS_INFO,
  [`Any ${T.FOLLOW_UP}`]: T.ANY_FOLLOWUP_INFO,
  [T.DASHBOARD]: T.DASHBOARD_INFO,
  [T.REPORTS]: T.REPORT_INFO,
  [T.GLOBAL_SEARCH]: T.GLOBAL_SEARCH_INFO,
  [T.MESSAGING]: T.MESSAGING_INFO,
  [T.TAXES]: T.TAXES_INFO,
  [T.TAX_APPLICATION]: T.TAX_APPLICATION_INFO,
  [T.ZONES]: T.ZONES_INFO,
  [T.NOTIFICATIONS]: T.NOTIFICATIONS_INFO,
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.INSPECTIONS]: T.INSPECTIONS_PERMISSION_INFO,
}

export const OFFICE_RECORDS = {
  [T.SETTINGS]: [T.SETTINGS, `${T.ROLE}s`, T.USER, T.RESET_PASSWORD],
  [T.PRICING_MANAGER]: [T.PRICING_MANAGER, T.TAXES, T.TAX_APPLICATION, T.ZONES],
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.BILLING]: [
    T.BILLING,
    T.CUSTOMER_BILLING_PROFILE,
    `${T.INVOICE}s`,
    T.POST_INVOICES_PAYMENT,
    T.PAYMENTS,
    T.ACCOUNT_PERIOD_LOCK,
    T.CHANGE_DATE_ON_INVOICED_WORK_ORDERS,
  ],
  [T.CUSTOMER_MANAGER]: [T.SERVICE, T.CONFIGURED_SERVICE_PRICE, T.CUSTOMER_MANAGER],
  [T.ROUTE_MANAGER]: [T.ROUTE_MANAGER],
  [T.FOLLOW_UP]: [`${T.FOLLOW_UP}s`],
  [T.REPORTING]: [T.REPORTS, T.GLOBAL_SEARCH],
  [T.MESSAGING]: [T.MESSAGING],
  [T.NOTIFICATIONS]: [T.NOTIFICATIONS],
  // eslint-disable-next-line no-restricted-syntax -- rows are label-keyed until roles.js migrates (i18n.md)
  [T.REVIEW]: [T.INSPECTIONS],
}

export const LIST_ROLES_HEADER_VALUES = [
  { filter: false, name: T.ROLE_NAME, sort: false },
  { filter: false, name: T.EMPLOYEES, sort: false },
  { filter: false, name: T.LAST_UPDATED, sort: false },
]

export const INITIAL_ROLE_VALUES = {
  active: true,
  allowOfficeLogin: true,
  allowRoadLogin: true,
  profileName: '',
  userType: ROAD_PERMISSION,
  roadTab: T.DISPLAY,

  settingsCrud: NO_ACCESS_PERMISSION,
  permissionsCrud: NO_ACCESS_PERMISSION,
  userCrud: NO_ACCESS_PERMISSION,
  resetPasswordCrud: NO_ACCESS_PERMISSION,
  pricingManagerCrud: NO_ACCESS_PERMISSION,
  billingCrud: NO_ACCESS_PERMISSION,
  customerBillingProfileCrud: NO_ACCESS_PERMISSION,
  invoicesCrud: NO_ACCESS_PERMISSION,
  postInvoicesPaymentCrud: NO_ACCESS_PERMISSION,
  paymentsCrud: NO_ACCESS_PERMISSION,
  lockDateCrud: NO_ACCESS_PERMISSION,
  invoicedWorkOrderDateCrud: NO_ACCESS_PERMISSION,
  serviceCrud: NO_ACCESS_PERMISSION,
  configuredServicePriceCrud: NO_ACCESS_PERMISSION,
  customerManagerCrud: NO_ACCESS_PERMISSION,
  routeManagerCrud: NO_ACCESS_PERMISSION,
  followUpCrud: NO_ACCESS_PERMISSION,
  anyFollowUpCrud: NO_ACCESS_PERMISSION,
  dashboardCrud: NO_ACCESS_PERMISSION,
  reportsCrud: NO_ACCESS_PERMISSION,
  globalSearchCrud: NO_ACCESS_PERMISSION,
  messagingCrud: NO_ACCESS_PERMISSION,
  taxCrud: NO_ACCESS_PERMISSION,
  taxApplicationCrud: NO_ACCESS_PERMISSION,
  geoZoneCrud: NO_ACCESS_PERMISSION,
  // Read by default, unlike every other permission: an inbox is per-user and RLS already scopes it
  // to the caller, so defaulting closed hides a user's own notifications from them.
  notificationCrud: READ_PERMISSION,
  inspectionsCrud: NO_ACCESS_PERMISSION,

  mrcShowMiles: true,
  mrcPurchaseOrder: true,
  mrcMaterial: true,
  mrcMeasure: true,
  mrcService: true,
  mrcSchedule: true,
  mrcSequence: true,
  mrcDate: true,
  mrcQuantity: true,

  dcSafety: NONE,
  dcDelay: NONE,
  dcNoAccess: NONE,
  dcDamage: NONE,
  dcOverloaded: NONE,
  dcExtraItem: NONE,
  dcSpecialItem: NONE,
  dcContamination: NONE,
  dcServiceReview: NONE,
  dcWeight: NONE,
  dcNoPayment: NONE,
  dcNotOut: NONE,
  dcCamera: NONE,
  dcSignature: NONE,
  dcNote: NONE,
  dcSerialNumber: NONE,

  customerInformationCrud: NO_ACCESS_PERMISSION,
  truckCrud: NO_ACCESS_PERMISSION,
  routeCrud: NO_ACCESS_PERMISSION,
  autocompleteCrud: NO_ACCESS_PERMISSION,
  timerCrud: NO_ACCESS_PERMISSION,
  inspectionRepairsCrud: NO_ACCESS_PERMISSION,
}

export const OFFICE_ROAD_OPTIONS = [
  {
    key: T.OFFICE,
    value: OFFICE_PERMISSION,
  },
  {
    key: T.ROAD,
    value: ROAD_PERMISSION,
  },
]
